<template>
  <div class="notice contents">
    <h2 class="page-title">공지사항</h2>

    <div class="notice-wrap" v-if="notices.length">
      <accordion multiple>
        <accordion-item v-for="item in notices" :key="item.id">
          <template slot="accordion-trigger">
            <div class="acc-tit">
              <span class="tit">{{ item.title }}</span>
              <div class="acc-right">
                <span class="date">{{ item.date }}</span>
                <i class="acc-arrow" aria-hidden="true"></i>
              </div>
            </div>
          </template>
          <template slot="accordion-content">
            <li class="acc-content">
              <div class="desc" v-if="item.content" v-html="item.content"></div>
              <img
                v-if="item.signature"
                :src="item.signature"
                alt="대표이사 최복규, 대표이사 강승진"
                class="signature"
                @load="onAccordionImageLoad"
              />
              <a
                v-if="item.file"
                :href="item.file"
                target="_blank"
                rel="noopener noreferrer"
                class="file-link"
              >
                첨부파일 보기
              </a>
            </li>
          </template>
        </accordion-item>
      </accordion>
    </div>

    <p class="empty" v-else>등록된 게시물이 없습니다.</p>
  </div>
</template>

<script>
  import Accordion from "@/components/global/accordion";
  import AccordionItem from "@/components/global/accodion-item";
  import notices from "@/data/notices";

  export default {
    name: "Notice",
    components: {
      Accordion,
      AccordionItem
    },
    data() {
      return {
        notices
      };
    },
    methods: {
      onAccordionImageLoad(event) {
        const accordionContent = event.target.closest(".accordionContent");
        if (accordionContent) {
          accordionContent.style.height = "auto";
        }
      }
    },
    metaInfo() {
      return {
        title: "공지사항",
        titleTemplate: "%s | e · motion",
        meta: [
          {
            property: "og:title",
            content: "공지사항 | e · motion",
            vmid: "og:title"
          },
          {
            property: "og:site_name",
            content: "이모션글로벌 | MAKE GREATNESS emotion global",
            vmid: "og:site_name"
          },
          {
            property: "og:url",
            content: "https://www.emotion.co.kr/notice/",
            vmid: "og:url"
          }
        ]
      };
    }
  };
</script>

<style lang="scss" scoped>
  .notice {
    padding-bottom: 160px;
  }

  .page-title {
    margin-top: 200px;
    font-size: 44px;
    font-weight: 700;
    letter-spacing: -0.05em;
    color: #000;
  }

  .notice-wrap {
    margin-top: 80px;
    box-sizing: border-box;

    .accordion {
      border-top: 1px solid #000;
    }

    .acc-tit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 32px 20px;
      font-size: 18px;
      letter-spacing: -0.05em;
      color: #333;
      box-sizing: border-box;


      .tit {
        flex: 1;
        min-width: 0;
        padding-right: 40px;
        font-weight: 700;
      }

      .acc-right {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: 24px;
      }

      .date {
        font-size: 16px;
        font-weight: 400;
        color: #a0a0a0;
      }

      .acc-arrow {
        flex-shrink: 0;
        width: 16px;
        height: 8px;
        background: url(../../assets/images/career/acc-off.svg) no-repeat center/cover;
        transition: background 200ms ease-in-out;
      }
    }

    .acc-content {
      padding: 10px 20px 40px;
      box-sizing: border-box;

      .desc {
        font-size: 16px;
        line-height: 28px;
        letter-spacing: -0.03em;
        color: #333;
        word-break: keep-all;

        ::v-deep .sub-tit {
          display: block;
          margin-bottom: 32px;
          font-size: 20px;
          font-weight: 700;
          line-height: 32px;
          letter-spacing: -0.05em;
          color: #000;
        }

        ::v-deep p {
          margin: 0;

          & + p {
            margin-top: 24px;
          }
        }

        ::v-deep .closing {
          margin-top: 32px;
        }

        ::v-deep .ethics-doc {
          .ethics-title {
            margin-bottom: 40px;
            font-size: 26px;
            font-weight: 700;
            text-align: center;
            letter-spacing: 0.2em;
            color: #000;
          }

          .ethics-company {
            margin: -24px 0 48px;
            font-size: 18px;
            font-weight: 700;
            text-align: center;
            color: #000;
          }

          .ethics-chapter {
            margin: 80px 0 40px;
            font-size: 20px;
            font-weight: 700;
            text-align: center;
            color: #000;
          }

          .ethics-supplement {
            margin-top: 56px;
          }

          .ethics-article {
            margin: 32px 0 16px;
            font-size: 16px;
            font-weight: 700;
            color: #000;
            text-decoration: none;
          }

          .ethics-intro p + p {
            margin-top: 24px;
          }

          .ethics-sub-sections {
            padding-left: 20px;

            .ethics-list {
              padding-left: 16px;
            }
          }

          .ethics-list {
            margin: 0;
            padding: 0;
            list-style: none;

            > li + li {
              margin-top: 12px;
            }
          }

          .ethics-sub-list {
            margin: 12px 0 0;
            padding-left: 20px;
            list-style: none;

            > li + li {
              margin-top: 8px;
            }
          }

          p {
            margin: 0;
          }
        }

        ::v-deep .notice-map {
          display: block;
          width: 100%;
          margin: 32px 0;
        }

        ::v-deep .notice-press-img {
          display: block;
          width: 100%;
          margin: 0 0 32px;
        }

        ::v-deep .notice-source {
          margin-top: 32px;

          a {
            font-weight: 700;
            color: $red;
            border-bottom: 1px solid $red;
          }
        }

        ::v-deep .address-info {
          margin: 32px 0;
          padding: 24px 0;
          border-top: 1px dashed #ccc;
          border-bottom: 1px dashed #ccc;

          p {
            margin: 0;

            & + p {
              margin-top: 12px;
            }
          }
        }

        ::v-deep .sign-off {
          margin-top: 48px;
          text-align: right;

          p {
            margin: 0;

            & + p {
              margin-top: 8px;
            }
          }

          .company {
            margin-bottom: 0;
            font-size: 18px;
          }
        }
      }

      .signature {
        display: block;
        margin-top: 16px;
        margin-left: auto;
        width: auto;
        max-width: 320px;
        height: auto;
      }

      .file-link {
        display: inline-block;
        margin-top: 24px;
        font-size: 16px;
        font-weight: 700;
        color: $red;
        border-bottom: 1px solid $red;
      }
    }
  }

  .empty {
    margin-top: 120px;
    padding: 80px 0;
    font-size: 18px;
    text-align: center;
    color: #a0a0a0;
    letter-spacing: -0.03em;
  }

  ::v-deep .accordionItem {
    border-bottom-color: #ddd;
  }

  ::v-deep .accordionTrigger.accordionTriggerActive {
    .acc-tit {
      color: $red;

      .tit {
        color: $red;
      }

      .acc-arrow {
        background-image: url(../../assets/images/career/acc-on.svg);
      }
    }
  }
</style>
